const SCROLL_OFFSET = 100;
class ModalActionHandler {
    constructor() {
        this.modal = document.getElementById("horaEventRegisterModal");
        if (!this.modal) {
            this.bindScrollEvent();
            return;
        }
        this.closeButton = document.getElementById("horaEventRegisterModalClose");
        this.bindModalEvents();
    }
    bindScrollEvent() {
        const registerButtons = document.querySelectorAll("[data-action-register]");
        if (registerButtons.length === 0) {
            return;
        }
        const registerContainer = document.getElementById("horaEventRegisterContainer");
        if (!registerContainer) {
            return;
        }
        registerButtons.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault();
                const containerPosition = registerContainer.getBoundingClientRect().top +
                    window.scrollY -
                    SCROLL_OFFSET;
                window.scrollTo({
                    top: containerPosition,
                    behavior: "smooth",
                });
            });
        });
    }
    bindModalEvents() {
        const registerButtons = document.querySelectorAll("[data-action-register]");
        registerButtons.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault();
                this.show();
            });
        });
        this.closeButton.addEventListener("click", () => {
            this.hide();
        });
        this.modal.addEventListener("click", (event) => {
            if (event.target === this.modal) {
                this.hide();
            }
        });
        document.addEventListener("keydown", (event) => {
            // if (event.key === "Escape") {
            //   this.hide();
            // }
        });
    }
    show() {
        this.modal.style.display = "flex";
        this.modal.setAttribute("aria-hidden", "false");
        this.modal.setAttribute("aria-modal", "true");
    }
    hide() {
        this.modal.style.display = "none";
        this.modal.setAttribute("aria-hidden", "true");
        this.modal.setAttribute("aria-modal", "false");
        // Reset the form inside the modal
        const form = this.modal.querySelector("form");
        if (form) {
            form.reset();
        }
    }
}
export function initRegisterModal() {
    new ModalActionHandler();
}
